import { getComcastAdInfo } from './adInfo/getComcastAdInfo'
import { getTizenAdInfo } from './adInfo/getTizenAdInfo'
import { getWebAdInfo } from './adInfo/getWebAdInfo'
import { getXboxAdInfo } from './adInfo/getXboxAdInfo'
import { drmByPlatform } from './helpers/drmByPlatform'
import { getComcastNativeInfo } from './helpers/getComcastNativeInfo'
import { getDeviceName } from './helpers/getDeviceName'
import { getFormFactor } from './helpers/getFormFactor'
import { getPlatform } from './helpers/getPlatform'
import { getTizenNativeInfo } from './helpers/getTizenNativeInfo'
import { getUserAgent } from './helpers/getUserAgent'
import { getXboxNativeInfo } from './helpers/getXboxNativeInfo'
import { isSafari } from './helpers/isSafari'
import { TDeviceInfo } from './types'

export const getDeviceInfo = async (): Promise<TDeviceInfo> => {
  const platform = getPlatform()
  let baseDeviceInfo: TDeviceInfo = { platform }
  switch (platform) {
    case 'tv_xboxone':
      baseDeviceInfo = {
        ...baseDeviceInfo,
        ...(await getXboxNativeInfo()),
      }
      return {
        ...baseDeviceInfo,
        platform,
        browser: 'device',
        deviceName: getDeviceName(platform),
        drmInfo: drmByPlatform.xbox,
        adInfo: getXboxAdInfo(baseDeviceInfo),
        formFactor: getFormFactor(baseDeviceInfo),
        userAgent: getUserAgent(),
        backButtonExits: false,
      }
    case 'tv_samsung':
      baseDeviceInfo = baseDeviceInfo = {
        ...baseDeviceInfo,
        ...(await getTizenNativeInfo()),
      }
      return {
        ...baseDeviceInfo,
        platform,
        browser: 'device',
        deviceName: getDeviceName(platform),
        drmInfo: drmByPlatform.tizen,
        adInfo: getTizenAdInfo(baseDeviceInfo),
        formFactor: getFormFactor(baseDeviceInfo),
        userAgent: getUserAgent(),
        backButtonExits: true,
        showExitConfirmation: true,
      }
    case 'hbbtv':
      baseDeviceInfo = baseDeviceInfo = {
        ...baseDeviceInfo,
        ...(await getComcastNativeInfo()),
      }
      return {
        ...baseDeviceInfo,
        platform,
        browser: 'device',
        drmInfo: drmByPlatform.comcast,
        adInfo: getComcastAdInfo(baseDeviceInfo),
        formFactor: getFormFactor(baseDeviceInfo),
        userAgent: getUserAgent(),
        backButtonExits: true,
        showExitConfirmation: false,
      }
    default:
      const _isSafari = isSafari()
      return {
        platform,
        browser: _isSafari ? 'safari' : 'general',
        deviceName: getDeviceName(platform),
        drmInfo: _isSafari ? drmByPlatform.safari : drmByPlatform.browser,
        adInfo: getWebAdInfo(),
        formFactor: getFormFactor(baseDeviceInfo),
        userAgent: getUserAgent(),
        backButtonExits: false,
      }
  }
}
